export default abstract class Component {
    protected _props: object;

    protected constructor(props: object = {}) {
        this._props = props
    }

    abstract init(): void;
}